import type { BlueprintAccessibilityLabelModifier } from '@/grove-blueprints/generated-types'

import type { BlueprintBindings } from '../../blueprint-bindings'
import type { ResolvedModifiers } from './resolve-modifiers'
import { resolveTextValue } from './resolve-text-value'

export function resolveAccessibilityLabelModifier(
  modifier: BlueprintAccessibilityLabelModifier,
  bindingValues: BlueprintBindings['bindingValues'],
  localizedString: (key: string) => string,
) {
  const attributes: ResolvedModifiers['attributes'] = {}

  attributes['aria-label'] = resolveTextValue(
    modifier.label,
    localizedString,
    bindingValues,
  )

  return attributes
}
